import SelectScrap from "../pages/selectuser/components/SelectScrap";
import UploadDocument from "../pages/selectuser/components/UploadDocument";
import GSTNumber from "../pages/selectuser/gstDocument/GSTNumber";
import VerifyGstDetail from "../pages/selectuser/gstDocument/components/VerifyGstDetail";
// import UserType from "../pages/selectuser/components/UserType";

import PageNotFound from "../pages/commanPage/errorPage/PageNotFound";
import UserVerification from "../pages/selectuser/UserVerification";

export const UnCompletedAccountRoutes = [
  {
    path: "/",
    element: <UserVerification />,
    children: [
      {
        path: "/",
        element: <GSTNumber />,
      },
      {
        path: "/verify-gst-details/:id",
        element: <VerifyGstDetail />,
      },
      {
        path: "/uploadDocument",
        element: <UploadDocument />,
      },
    ],
  },
  {
    path: "/select-scrap",
    element: <SelectScrap />,
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
];
